import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../config";
import {
  Row,
  Col,
  Container,
  Input,
  FormGroup,
  Table,
  Nav,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Modal,
} from "reactstrap";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Correct from "../../../assets/image/Correct.svg";
import Close from "../../../assets/image/Close.svg";




function User() {
  let navigate = useNavigate();
  let [checked, setChecked] = useState(false);

  const [searchStatus, setSearchStatus] = useState("");
  let [isChecked, setIsChecked] = useState(false);
  const [startDate, setStartDate] = useState(new Date());

  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [showDropdown, setShowDropdown] = useState(false);
  const [format, setFormat] = useState("pdf");
  const [period, setPeriod] = useState("Monthly");
  const [sortOrder, setSortOrder] = useState(null); // "asc" | "desc" | null

  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [selected, setSelected] = useState("All");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showCompaniesModal, setShowCompaniesModal] = useState(false);
  const [userCompanies, setUserCompanies] = useState([]);

  const dropdownRef = useRef(null);

  const [editUserData, setEditUserData] = useState({
    id: null,
    name: "",
    email: "",
    role_id: "",
    phone_number: "",
    aadhaar_number: "",
    DOJ: "",
    office_address: "",
    status: true,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.put(`${API_URL}/userRole/${editUserData.id}`, {
        name: editUserData.name,
        email: editUserData.email,
        role_id: editUserData.role_id,
        phone_number: editUserData.phone_number,
        aadhaar_number: editUserData.aadhaar_number,
        DOJ: editUserData.DOJ,
        office_address: editUserData.office_address,
        status: editUserData.status,
      });

      setShowModal(false);
      // Optionally refresh the list after update
      fetchUsers && fetchUsers();
      toast.success("User updated successfully!");
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
        "Something went wrong while updating user."
      );
    }
  };

  const fetchUserCompanies = async (userId) => {
    try {
      const res = await fetch(`${API_URL}/userRole/comp/${userId}`);
      const data = await res.json();
      setUserCompanies(data.companies || []);
      setShowCompaniesModal(true);
    } catch (err) {
      console.error("Failed to fetch companies:", err);
      toast.error("Failed to load company data");
    }
  };

  const openEditModal = async (id) => {
    try {
      const response = await axios.get(`${API_URL}/userRole/${id}`);
      const data = response.data.data;

      setEditUserData({
        id: data.id,
        name: data.name || "",
        email: data.email || "",
        role_id: data.role_id || "",
        phone_number: data.phone_number || "",
        aadhaar_number: data.aadhaar_number || "",
        DOJ: data.DOJ || "",
        office_address: data.office_address || "",
        status: data.status,
      });

      setShowModal(true);
    } catch (err) {
      console.error("Error fetching user by ID:", err);
    }
  };

  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;

  const [formData, setFormData] = useState({
    role_id: "",
    name: "",
    email: "",
    phone_number: "",
    office_address: "",
    aadhaar_number: "",
    DOJ: "",
    status: "1", // default to active
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCreateUser = async () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;
    const aadhaarRegex = /^[0-9]{12}$/;

    if (!formData.role_id) errors.role_id = "Please select a user type.";

    if (!formData.name.trim()) errors.name = "Full name is required.";

    if (!formData.email.trim()) {
      errors.email = "Email is required.";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Enter a valid email address.";
    }

    if (!formData.phone_number.trim()) {
      errors.phone_number = "Phone number is required.";
    } else if (!phoneRegex.test(formData.phone_number)) {
      errors.phone_number = "Phone number must be 10 digits.";
    }

    if (!formData.office_address.trim())
      errors.office_address = "Office address is required.";

    if (formData.aadhaar_number && !aadhaarRegex.test(formData.aadhaar_number)) {
      errors.aadhaar_number = "Aadhaar number must be 12 digits.";
    }

    if (!formData.DOJ) errors.DOJ = "Please select date of joining (DOJ).";

    if (formData.status === "") errors.status = "Please select a status.";

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;

    try {
      const response = await axios.post(`${API_URL}/userRole/create`, formData);

      if (response.status === 201) {
        toast.success("User created successfully!");
        setShow(false);
        setFormData({
          role_id: "",
          name: "",
          email: "",
          phone_number: "",
          office_address: "",
          aadhaar_number: "",
          DOJ: "",
          status: "",
        });
        setFormErrors({});
        fetchUsers();
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
        "Something went wrong while creating user."
      );
    }
  };

  // Role filter is now handled in the search useEffect to work together with search

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen1]);

  const [selectedItems, setSelectedItems] = useState(["Aaji Care", "ICICI"]);
  const [selectedItems1, setSelectedItems1] = useState(["Dadar", "Thane"]);
  const [search1, setSearch1] = useState("");
  const companies = [
    "Aaji Care",
    "McDonalds",
    "ICICI",
    "Godrej",
    "TATA Mahindra",
  ];
  const companies1 = ["Thane", "Vashi", "Kurla", "NaviMumbai", "Dadar"];

  const [endDate, setEndDate] = useState(null);

  const toggleSelection = (item) => {
    setSelectedItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };
  const toggleSelection1 = (item) => {
    setSelectedItems1((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_URL}/userRole`);
      setUsers(response.data.data);
      setAllUsers(response.data.data);
      setFilteredUsers(response.data.data); // Initialize filtered users
    } catch (err) {
      console.error("Error fetching users", err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const sortUsers = (order) => {
    const sorted = [...filteredUsers].sort((a, b) => {
      const nameA = a.name?.toLowerCase() || "";
      const nameB = b.name?.toLowerCase() || "";

      if (order === "asc") return nameA.localeCompare(nameB);
      if (order === "desc") return nameB.localeCompare(nameA);
      return 0;
    });

    setFilteredUsers(sorted);
    setSortOrder(order);
  };
  useEffect(() => {
    if (!searchQuery.trim()) {
      // If no search query, apply role filter if any
      if (selected === "All") {
        setFilteredUsers(allUsers);
      } else {
        setFilteredUsers(
          allUsers.filter((user) => getRoleName(user.role_id) === selected)
        );
      }
    } else {
      const searchLower = searchQuery.toLowerCase();
      const filtered = allUsers.filter((user) => {
        // Search by user name
        const matchesName = user.name?.toLowerCase().includes(searchLower);
        
        // Also apply role filter if not "All"
        const matchesRole = selected === "All" || getRoleName(user.role_id) === selected;
        
        return matchesName && matchesRole;
      });
      setFilteredUsers(filtered);
    }
    setCurrentPage(1); // Reset to page 1 when search changes
  }, [searchQuery, allUsers, selected]);

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  return (
    <section className="lyt-section typ-min-height p-5">
      <div className=" ">
        <div
          className="d-flex justify-content-between "
          style={{ gap: "10px", width: "100%" }}
        >
          <div className="d-flex align-items-center w-100">
            <div className="d-flex justify-content-between  w-100 ">
              <div>
                <div className="d-flex gap-4">
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      gap: "8px",
                    }}
                  >
                    <div style={{ position: "relative", zIndex: 1050 }}>
                      <button
                        className="btn  shadow-sm d-flex align-items-center justify-content-center  all-btn "
                        onClick={() => {
                          setShowSearch(!showSearch);

                        }}

                      >
                        {showSearch ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="black"
                            viewBox="0 0 16 16"
                          >
                            <path d="M4.646 4.646a.5.5 0 011.415 0L8 6.586l1.939-1.94a.5.5 0 01.707.708L8.707 7.293l1.939 1.94a.5.5 0 01-.707.707L8 8.001 6.061 9.94a.5.5 0 11-.707-.707L7.293 8 5.354 6.061a.5.5 0 010-.707z" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="black"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0
            1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zm-5.24 1.106a5 5 0 1 1
            0-10 5 5 0 0 1 0 10z"
                            />
                          </svg>
                        )}
                      </button>

                      {showSearch && (
                        <input
                          className="fs-12"
                          type="text"
                          placeholder="Search by user name"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          style={{
                            position: "absolute",
                            top: "45px",
                            left: 0,
                            width: "260px",
                            padding: "8px 10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            zIndex: 1050,
                          }}
                        />
                      )}
                    </div>
                  </div>

                  <div className="dropdown">
                    <button
                      className="btn dropdown-toggle w-100 fs-12 sorbtn "
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"

                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#ffffff")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#ffffff")
                      }
                    >
                      {selected}
                    </button>

                    <ul
                      className="dropdown-menu w-100 fs-12"
                      style={{
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        borderRadius: "6px",
                      }}
                    >
                      {[
                        "All",
                        "Compliance Officer",
                        "Auditor",
                        "Approver",
                        "Super Admin",
                      ].map((role) => (
                        <li key={role}>
                          <button
                            className="dropdown-item d-flex justify-content-between"
                            style={{
                              padding: "10px",
                              fontSize: "12px",
                              fontWeight: "500",
                              color: "#333",
                            }}
                            onClick={() => setSelected(role)}
                          >
                            {role} {selected === role && "✔️"}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex gap-4">
                  <div className="">
                    <button
                      className="btn  w-100 userbtn"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"

                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#ffffff")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#ffffff")
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3 3h10v1H3V3zm0 3h7v1H3V6zm0 3h4v1H3V9zm8 2h3v-3h1v3h3l-3.5 3.5L11 11z" />
                      </svg>
                      <span className="fs-12">Sort</span>
                    </button>

                    <ul className="dropdown-menu p-2 shadow">
                      <li className="fs-12">
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            setFilteredUsers(allUsers); // Reset to original
                            setSortOrder(null);
                          }}
                        >
                          No sorting
                        </button>
                      </li>
                      <li className="fs-12">
                        <button
                          className="dropdown-item"
                          onClick={() => sortUsers("desc")}
                        >
                          <span className="d-flex justify-content-between">
                            Reverse Alphabetical{" "}
                            <span className="text-muted fs-12">Z-A</span>
                          </span>
                        </button>
                      </li>
                      <li className="fs-12">
                        <button
                          className="dropdown-item"
                          onClick={() => sortUsers("asc")}
                        >
                          <span className="d-flex justify-content-between ">
                            Alphabetical <span className="text-muted fs-12">A-Z</span>
                          </span>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <button
                      className="btn fs-12"
                      style={{
                        backgroundColor: "#24273D",
                        color: "white",
                        fontSize: "12px",
                        fontWeight: "500",
                        border: "none",
                        height: "32px",
                        padding: "0 14px",
                        borderRadius: "6px",
                      }}
                      onClick={() => setShow(true)}
                    >
                      Create User
                    </button>

                    {show && (
                      <div
                        className="modal d-block"
                        tabIndex="-1"
                        role="dialog"
                      >
                        <div className="modal-dialog modal-lg" role="document">
                          <div
                            className="modal-content p-3"
                            style={{ borderRadius: "10px" }}
                          >
                            <div className="modal-header">
                              <h5 className="modal-title fs-12">CREATE USER</h5>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShow(false)}
                              ></button>
                            </div>

                            <div className="modal-body">
                              <div
                                className="mb-3"
                                style={{
                                  position: "relative",
                                  overflow: "visible",
                                  zIndex: 1000,
                                }}
                              >
                                <label className="form-label fs-12">
                                  User Type
                                  <span className=" text-danger fs-12">*</span>
                                </label>

                                <select
                                  className="form-control fs-12"
                                  name="role_id"
                                  value={formData.role_id}
                                  onChange={handleChange}
                                  style={{
                                    appearance: "none",
                                    WebkitAppearance: "none",
                                    MozAppearance: "none",
                                    paddingRight: "2rem",
                                    backgroundColor: "#fff",
                                    backgroundImage:
                                      'url(\'data:image/svg+xml;utf8,<svg fill="%23333" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>\')',
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "right 0.75rem center",
                                    backgroundSize: "16px 16px",
                                  }}
                                >
                                  <option value="" className="fs-12">Select</option>
                                  <option value="1" className="fs-12">Super Admin</option>
                                  <option value="3" className="fs-12">Compliance officer</option>
                                  <option value="2" className="fs-12">Auditor</option>
                                  <option value="4" className="fs-12">Approver</option>
                                </select>

                                {formErrors.role_id && (
                                  <small className="text-danger">
                                    {formErrors.role_id}
                                  </small>
                                )}
                              </div>

                              <div className="mb-3">
                                <label className="form-label fs-12">
                                  User Full Name
                                  <span className="fs-6 text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control fs-12"
                                  name="name"
                                  value={formData.name}
                                  placeholder="Enter here"
                                  onChange={handleChange}
                                />
                                {formErrors.name && (
                                  <small className="text-danger fs-12">
                                    {formErrors.name}
                                  </small>
                                )}
                              </div>

                              <div className="row">
                                <div className="col">
                                  <label className="form-label fs-12">
                                    Email
                                    <span className="text-danger fs-12">*</span>
                                  </label>
                                  <input
                                    type="email"
                                    className="form-control fs-12"
                                    name="email"
                                    value={formData.email}
                                    placeholder="Enter here"
                                    onChange={handleChange}
                                  />
                                  {formErrors.email && (
                                    <small className="text-danger fs-12">
                                      {formErrors.email}
                                    </small>
                                  )}
                                </div>

                                <div className="col">
                                  <label className="form-label fs-12">
                                    Phone Num
                                    <span className=" text-danger fs-12">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control fs-12"
                                    name="phone_number"
                                    value={formData.phone_number}
                                    placeholder="Enter here"
                                    onChange={handleChange}
                                  />
                                  {formErrors.phone_number && (
                                    <small className="text-danger">
                                      {formErrors.phone_number}
                                    </small>
                                  )}
                                </div>
                              </div>

                              <div className="mb-3 mt-3">
                                <label className="form-label fs-12">
                                  Address
                                  <span className="text-danger fs-12">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control fs-12"
                                  name="office_address"
                                  value={formData.office_address}
                                  placeholder="Enter here"
                                  onChange={handleChange}
                                />
                                {formErrors.office_address && (
                                  <small className="text-danger fs-12">
                                    {formErrors.office_address}
                                  </small>
                                )}
                              </div>

                              <div className="mb-3">
                                <label className="form-label fs-12">
                                  Aadhaar Number

                                </label>
                                <input
                                  type="text"
                                  className="form-control fs-12"
                                  name="aadhaar_number"
                                  value={formData.aadhaar_number}
                                  placeholder="Enter here"
                                  onChange={handleChange}
                                />
                                {formErrors.aadhaar_number && (
                                  <small className="text-danger fs-12">
                                    {formErrors.aadhaar_number}
                                  </small>
                                )}
                              </div>

                              <div className="mb-3">
                                <label className="form-label fs-12">
                                  DOJ
                                  <span className="text-danger fs-12">*</span>
                                </label>
                                <input
                                  type="date"
                                  className="form-control fs-12"
                                  name="DOJ"
                                  value={formData.DOJ}
                                  onChange={handleChange}
                                />
                                {formErrors.DOJ && (
                                  <small className="text-danger fs-12">
                                    {formErrors.DOJ}
                                  </small>
                                )}
                              </div>

                              <div className="mb-3">
                                <label className="form-label fs-12">
                                  Status
                                  <span className="fs-6 text-danger fs-12">*</span>
                                </label>
                                <select
                                  className="form-control fs-12"
                                  name="status"
                                  value={formData.status}
                                  onChange={handleChange}
                                  style={{
                                    appearance: "none",
                                    WebkitAppearance: "none",
                                    MozAppearance: "none",
                                    paddingRight: "2rem",
                                    backgroundColor: "#fff",
                                    backgroundImage:
                                      'url(\'data:image/svg+xml;utf8,<svg fill="%23333" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>\')',
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "right 0.75rem center",
                                    backgroundSize: "16px 16px",
                                  }}
                                >
                                  <option value="" className="fs-12">Select</option>
                                  <option value="1" className="fs-12">Active</option>
                                  <option value="0" className="fs-12">Inactive</option>
                                </select>
                                {formErrors.status && (
                                  <small className="text-danger fs-12">
                                    {formErrors.status}
                                  </small>
                                )}
                              </div>
                            </div>

                            <div className="modal-footer">
                              <button
                                className="btn fs-12"
                                style={{
                                  backgroundColor: "#24273D",
                                  color: "white",
                                  borderRadius: "6px",
                                  padding: "8px 12px",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  border: "none",
                                }}
                                onClick={handleCreateUser}
                              >
                                Create User
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4" style={{ position: "relative", zIndex: 1 }}>
        <div className="card-body p-0">
          <div className="table-responsive">
              <div className="table-scroll">
            <table className="table table-hover align-middle mt-0 rounded vertical-border">
              <thead className="bg-light text-nowrap fs-12 table-color">
                <tr>
                  {/* <th>
                    <input type="checkbox" />
                  </th> */}
                  <th>Sr No</th>
                  <th>Name</th>
                  <th>User Id</th>
                  <th>User Type</th>
                  <th>Phone No</th>
                  <th>Email</th>
                  <th>Joined</th>
                  <th>Status</th>
                  <th>Companies</th>
                  <th>Action</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody className="fs-12 table-color">
                {currentUsers.map((user, index) => (
                  <tr key={user.id}>
                    {/* <td>
                      <input type="checkbox" />
                    </td> */}
                    <td>{indexOfFirstUser + index + 1}</td>
                    <td>{user.name}</td>
                    <td>{`USR-${user.id}`}</td>
                    <td>{getRoleName(user.role_id)}</td>
                    <td>{user.phone_number}</td>
                    <td>{user.email || "-"}</td>

                    <td>{user.DOJ || "-"}</td>
                    {/* <td>
                      <button className="d-flex align-items-center border-0" 
                      style={{
                                    backgroundColor: "#E6FAF2",
                                    color: "#1DBF73",
                                    borderRadius: "20px",
                                    padding: "6px 12px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    display: "flex",
                                    gap: "6px",
                                  }}>
                           <img src={Correct} alt="correct" />
                            <img src={Close} alt="close" />
                        {user.status ? "Active" : "Inactive"}
                      </button>
                    </td> */}
                    <td>
                      <button
                        className="d-flex align-items-center border-0"
                        style={{
                          backgroundColor: user.status ? "#E6FAF2" : "#FDECEC",
                          color: user.status ? "#1DBF73" : "#E74C3C",
                          borderRadius: "20px",
                          padding: "6px 12px",
                          fontSize: "14px",
                          fontWeight: "500",
                          display: "flex",
                          gap: "6px",
                        }}
                      >
                        {/* ICON */}
                        {user.status ? (
                          <img src={Correct} alt="active" />
                        ) : (
                          <img src={Close} alt="inactive" />
                        )}

                        {/* TEXT */}
                        {user.status ? "Active" : "Inactive"}
                      </button>
                    </td>

                    <td>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          fetchUserCompanies(user.id);
                        }}
                      >
                        view companies
                      </a>
                    </td>

                    <td>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          openEditModal(user.id);
                          setShowModal(true);
                        }}
                      >
                        view & edit
                      </a>
                    </td>
                    <td>
                      <a className="fs-12"
                        href="#"
                        onClick={async (e) => {
                          e.preventDefault();
                          if (
                            window.confirm(
                              "Are you sure you want to delete this user?"
                            )
                          ) {
                            try {
                              const response = await fetch(
                                `${API_URL}/userRole/${user.id}`,
                                {
                                  method: "DELETE",
                                }
                              );

                              const result = await response.json();
                              if (response.ok) {
                                toast.success("User deleted successfully");
                                fetchUsers(); // Refresh user list
                              } else {
                                toast.error(`Failed: ${result.message}`);
                              }
                            } catch (error) {
                              console.error("Error deleting user:", error);
                              toast.error(
                                "Something went wrong while deleting the user"
                              );
                            }
                          }
                        }}
                      >
                        Delete
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
            {showCompaniesModal && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div
                    className="modal-content p-4"
                    style={{
                      borderRadius: "16px",
                      width: "500px",
                      maxWidth: "95%",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="modal-title fw-bold m-0">
                        Assigned Companies
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowCompaniesModal(false)}
                      />
                    </div>
                    {userCompanies.length > 0 ? (
                      <ul
                        style={{ paddingLeft: "20px", listStyleType: "disc" }}
                      >
                        {userCompanies.map((company, idx) => (
                          <li key={idx}>{company.company_name}</li>
                        ))}
                      </ul>
                    ) : (
                      <p>No companies assigned.</p>
                    )}
                  </div>
                </div>
              </div>
            )}

            {showModal && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div
                    className="modal-content p-4"
                    style={{
                      borderRadius: "16px",
                      width: "500px",
                      maxWidth: "95%",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="modal-title fw-bold m-0">EDIT USER</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowModal(false)}
                      />
                    </div>

                    <form onSubmit={handleSubmit}>
                      {/* Status */}
                      <div className="mb-3">
                        <label className="form-label d-block fw-semibold mb-2">
                          Status
                        </label>
                        <div>
                          <label className="me-4">
                            <input
                              type="radio"
                              name="status"
                              value={true}
                              checked={editUserData.status === true}
                              onChange={() =>
                                setEditUserData({
                                  ...editUserData,
                                  status: true,
                                })
                              }
                              className="form-check-input me-1"
                            />
                            Active
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="status"
                              value={false}
                              checked={editUserData.status === false}
                              onChange={() =>
                                setEditUserData({
                                  ...editUserData,
                                  status: false,
                                })
                              }
                              className="form-check-input me-1"
                            />
                            Inactive
                          </label>
                        </div>
                      </div>

                      {/* Role */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          User Type
                        </label>
                        <select
                          className="form-select"
                          value={editUserData.role_id}
                          disabled
                          onChange={(e) =>
                            setEditUserData({
                              ...editUserData,
                              role_id: parseInt(e.target.value),
                            })
                          }
                        >
                          <option value="1">Super Admin</option>
                          <option value="3">Compliance Officer</option>
                          <option value="2">Auditor</option>
                          <option value="4">Approver</option>
                        </select>
                      </div>

                      {/* User ID */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          User ID
                        </label>
                        <input
                          className="form-control"
                          value={editUserData.id}
                          disabled
                        />
                      </div>

                      {/* Full Name */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          User Full Name
                        </label>
                        <input
                          className="form-control"
                          value={editUserData.name}
                          onChange={(e) =>
                            setEditUserData({
                              ...editUserData,
                              name: e.target.value,
                            })
                          }
                        />
                      </div>

                      {/* Email and Phone */}
                      <div className="row mb-3">
                        <div className="col">
                          <label className="form-label fw-semibold">
                            Email
                          </label>
                          <input
                            className="form-control"
                            value={editUserData.email}
                            onChange={(e) =>
                              setEditUserData({
                                ...editUserData,
                                email: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="col">
                          <label className="form-label fw-semibold">
                            Phone Num
                          </label>
                          <input
                            className="form-control"
                            value={editUserData.phone_number}
                            onChange={(e) =>
                              setEditUserData({
                                ...editUserData,
                                phone_number: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>

                      {/* Address */}
                      <div className="mb-4">
                        <label className="form-label fw-semibold">
                          Address
                        </label>
                        <input
                          className="form-control"
                          value={editUserData.office_address || ""}
                          onChange={(e) =>
                            setEditUserData({
                              ...editUserData,
                              office_address: e.target.value,
                            })
                          }
                        />
                      </div>

                      {/* Button */}
                      <div className="text-end">
                        <button
                          type="submit"
                          className="btn"
                          style={{
                            backgroundColor: "#24273D",
                            color: "white",
                            padding: "10px 24px",
                            borderRadius: "8px",
                            fontWeight: "500",
                            fontSize: "14px",
                            border: "none",
                          }}
                        >
                          Save Changes
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Pagination */}
        <div className="d-flex justify-content-between align-items-center mt-4">
          {/* Page Selector Dropdown */}
          <div>
            <select
              className="form-select form-select-sm w-auto"
              value={currentPage}
              onChange={(e) => setCurrentPage(Number(e.target.value))}
            >
              {Array.from({ length: totalPages }, (_, i) => (
                <option key={i + 1} value={i + 1} className="fs-12">
                  Page {i + 1}
                </option>
              ))}
            </select>
          </div>

          {/* Pagination */}
          <nav>
            <ul className="pagination mb-0 d-flex align-items-center gap-2">
              {/* Previous */}
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link text-dark border-0 bg-transparent"
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                >
                  Previous
                </button>
              </li>

              {/* First Page & Dots */}
              {currentPage > 3 && (
                <>
                  <li className="page-item">
                    <button
                      className={`page-link fw-bold rounded-circle border-0 ${currentPage === 1
                          ? "bg-dark text-white rounded-circle"
                          : "bg-transparent text-dark"
                        }`}
                      onClick={() => setCurrentPage(1)}
                    >
                      1
                    </button>
                  </li>
                  <li className="page-item disabled">
                    <span className="page-link bg-transparent border-0">...</span>
                  </li>
                </>
              )}

              {/* Nearby Pages */}
              {Array.from({ length: totalPages }, (_, i) => i + 1)
                .filter(
                  (page) =>
                    page === 1 ||
                    page === totalPages ||
                    (page >= currentPage - 2 && page <= currentPage + 2)
                )
                .map((page) => (
                  <li
                    key={page}
                    className={`page-item ${currentPage === page ? "active" : ""
                      }`}
                  >
                    <button
                      className={`page-link fw-bold rounded-circle border-0 ${currentPage === page
                          ? "bg-dark text-white"
                          : "bg-transparent text-dark"
                        }`}
                      onClick={() => setCurrentPage(page)}
                      style={{
                        width: "36px",
                        height: "36px",
                        padding: 0,
                        lineHeight: "36px",
                        textAlign: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {page}
                    </button>
                  </li>
                ))}

              {/* Last Page & Dots */}
              {currentPage < totalPages - 2 && (
                <>
                  <li className="page-item disabled">
                    <span className="page-link bg-transparent border-0">
                      ...
                    </span>
                  </li>
                  <li className="page-item">
                    <button
                      className={`page-link fw-bold rounded-circle border-0 circle ${currentPage === totalPages
                          ? "bg-dark text-white"
                          : "bg-transparent text-dark"
                        }`}
                      onClick={() => setCurrentPage(totalPages)}
                    >
                      {totalPages}
                    </button>
                  </li>
                </>
              )}

              {/* Next */}
              <li
                className={`page-item ${currentPage === totalPages ? "disabled" : ""
                  }`}
              >
                <button
                  className="page-link text-dark border-0 bg-transparent"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </section>
  );
}

const getRoleName = (roleId) => {
  switch (roleId) {
    case 1:
      return "Super Admin";
    case 2:
      return "Auditor";
    case 3:
      return "Compliance Officer";
    case 4:
      return "Approver";
    default:
      return "Unknown";
  }
};

export default User;
